import { Component, OnInit } from '@angular/core';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AuthService } from '../../../../core/auth/auth.service';
import { ChangePasswordDialogComponent } from '../../../../core/auth/change-password-dialog/change-password-dialog.component';

@Component({
  selector: 'vex-sidenav-user-menu',
  templateUrl: './sidenav-user-menu.component.html',
  styleUrls: ['./sidenav-user-menu.component.scss'],
  imports: [MatRippleModule, MatIconModule, MatDialogModule],
  standalone: true
})
export class SidenavUserMenuComponent implements OnInit {
  constructor(
    private readonly popoverRef: VexPopoverRef,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  close(): void {
    setTimeout(() => this.popoverRef.close(), 250);
  }

  openChangePassword(): void {
    this.popoverRef.close();
    this.dialog.open(ChangePasswordDialogComponent, {
      width: '420px',
    });
  }

  logout(): void {
    this.popoverRef.close();
    this.authService.logout().subscribe({
      next: () => { /* session cleared, navigation handled by service */ },
      error: (err) => console.error('[Logout] error (session cleared anyway):', err)
    });
  }
}
